/* eslint-disable max-len */
export default {
  country: "Country",
  "state/city": "State/city",
  address: "Address",
  "consultation-value": "Value of consultation",
  "consultation-value-simple": "Consultation value",
  follow: "Follow",
  followed: "Followed",
  "see-complete-profile": "See full profile",
  consultation: "Consulting room",
  "return-home": "Go back",
  meet: "Meet",
  "consultation-type-inperson": "In person",
  "consultation-type-online": "Online",
  "schedule-appointment": "Appointment agenda",
  "appointment-question": "Is the medical consultation for you?",
  "first-name": "First name",
  "name-placeholder": "Enter the names",
  "first-surname": "First Surname",
  "surname-placeholder": "Enter the last name",
  gender: "Gender",
  "gender-placeholder": "Enter the gender",
  "birth-date": "Birth date",
  "birth-date-placeholder": "Enter date of birth",
  email: "Email",
  "email-placeholder": "Enter email",
  "country-code": "Country code",
  "phone-number": "Phone",
  "phone-number-placeholder": "304 632 7544",
  "bond-with-the-patient": "Bond with the patient",
  "bond-with-the-patient-placeholder": "Relationship you have with the patient",
  "reason-for-consultation": "Reason for consultation",
  "leave-your-message": "Leave your message",
  "leave-your-message-placeholder": "Create a precise and strategic introduction using keywords to boost your medical article.",
  "payment-method": "Payment method",
  "payment-method-placeholder": "Select payment method",
  yes: "Yes",
  no: "No",
  "schedule-appointment-modal": "Schedule appointment",
  "patient-name": "Name of patient",
  "year-of-birth": "Year of birth",
  age: "Age",
  "scheduled-with": "You have scheduled your appointment with",
  "appointment-email": "You will receive an email with all the information about your medical appointment.",
  "consultation-type": "Consultation type",
  confirm: "Confirm",
  "go-back": "Go back",
  "consultation-price": "Price per consultation",
  "first-consultation": "First consultation",
  "second-consultation": "Follow-up consultation",
  "selected-consultory": "Selected office",
  "select-appointment-type": "Select Appointment Type",
  online: "Online",
  "in-person": "In person",
  "office-schedule": "Office and schedule",
  "appointment-data": "Appointment data",
  processing: "Processing",
  "field-required": "Field required",
  "service-error": "Service error",
  "please-try-again-later": "Please, try again later",
  "invalid-characters": "Invalid characters",
  "invalid-email": "Invalid email",
  "configuration-not-found": "This doctor does not currently have open consultations",
  "appointment-confirmation": "Thank you for scheduling your appointment with Dr. Now",
  "appointment-confirmation-description": "You will receive an email with all the information about your medical appointment. Remember that the best doctors in the country are at Dr. Now.",
  "appointment-confirmation-button-forward": "Go to dashboard",
  "appointment-confirmation-button-backward": "Go back",
  "complete-profile": "See complete profile",
  "complete-profile-short": "See profile",
  "register-now": "Do not have your account yet? register now",
  register: "Register",
  "log-in": "Log in",
  years: "years",
  day: "Day",
  hour: "Hour",
  "valid-country-code": "Enter a valid country code",
  january: "january",
  february: "february",
  march: "march",
  april: "april",
  may: "may",
  june: "june",
  july: "july",
  august: "august",
  september: "september",
  october: "october",
  november: "november",
  december: "december",
  monday: "mon",
  tuesday: "tue",
  wednesday: "wed",
  thursday: "thu",
  friday: "fri",
  saturday: "sat",
  sunday: "sun",
};
